import type { Engine } from "../../../../royalur/engine/Engine.js";
import { BoardDirective } from "./BoardDirective.js";
import type { MoveBoardDirective } from "./MoveBoardDirective.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import type { GameState } from "../../../../royalur/engine/state/GameState.js";


export interface ReplayMoveProperties {
    wait: number;
    speed: number;
}


/**
 * A directive for rendering the dice.
 */
export class ReplayMovesBoardDirective extends BoardDirective {
    readonly moves: MoveBoardDirective[];
    readonly moveProperties?: ReplayMoveProperties[];

    constructor(
        directiveID: number,
        rules: Engine,
        moves: MoveBoardDirective[],
        moveProperties?: ReplayMoveProperties[],
    ) {
        super(directiveID, rules, moves[0].moveIndex);
        this.moves = moves;
        this.moveProperties = moveProperties;
    }

    override isLimboDirective(): boolean {
        return false;
    }

    override getState(): GameState {
        throw new Error("Replay moves board directive does not have a state");
    }

    override getActivePlayer(): PlayerType {
        throw new Error("Replay moves board directive does not have an active player");
    }
}
